export default __webpack_public_path__ + "static/media/yo2.ed0cef71.png";